import {Text} from '@gs-ux-uitoolkit-react/text';
import gsCustodySolutionsLogoBlack from "./../../assets/gsCustodySolutionsLogoBlack.svg";

export function Header({logoLinkTo}: { logoLinkTo?: string }) {
    const domain = window.location.hostname;
    // const isAdvisorSite = domain.includes('advisorsolutions');

    // if(isAdvisorSite)
    //     return (
    //         <div className="justify-between flex-1 flex flex-col min-[700px]:flex-row items-center px-16 xl:gap-72 lg:gap-24 md:gap-12 sm:gap-6">
    //              <img
    //                 className="w-[254px] p-6"
    //                 src={GSAdvisorSolutionsLogo}
    //                 alt="Logo - Goldman Sachs Advisor Solutions"
    //                 title="Logo - Goldman Sachs Advisor Solutions"/>
    //             <Text className="text-gray-70" typography="body02">
    //                 Interested in a relationship?
    //                 <a href="https://www.goldmansachs.com/what-we-do/FICC-and-equities/goldman-sachs-advisor-solutions/contact_us.html" target="_blank" className="text-blue-60 ml-2" aria-label="Opens in New Tab - Contact Us">Contact Us</a>
    //             </Text>
    //         </div>
    // );

//     Custody site
    return (
        <div className="justify-between flex-1 flex flex-col min-[700px]:flex-row items-center px-8 xl:gap-72 lg:gap-24 md:gap-12 sm:gap-6" data-qa-comp="header">
            {logoLinkTo
                ? <a href={logoLinkTo}><img className="w-[184px] m-8" src={gsCustodySolutionsLogoBlack} alt="Logo - Goldman Sachs Custody Solutions"  title="Goldman Sachs Custody Solutions - Sign in"/></a>
                : <img className="w-[184px] m-8" src={gsCustodySolutionsLogoBlack} alt="Logo - Goldman Sachs Custody Solutions"  title="Logo - Goldman Sachs Custody Solutions"/>}
            <div className="flex flex-col justify-center">
                <Text className="text-gray-70" typography="textBody02Regular">
                    Interested in learning more about GSCS?
                </Text>
                <a href="https://www.goldmansachs.com/what-we-do/FICC-and-equities/goldman-sachs-advisor-solutions/contact_us.html" target="_blank" className="text-blue-60" aria-label="Opens in New Tab - Click here" data-qa-comp="get-started-link">Click here</a>
            </div>
        </div>
    );
}

